/**
 * WEB-2783 — метки посетителя, которые страница умной ссылки передаёт серверу.
 *
 * ЗАЧЕМ. Клиент вписывает в ВНЕШНИЙ адрес направления умной ссылки метки
 * (`{click_id}`, `{utm_source}`…), сервер подставлять их умеет
 * (`backend/src/domains/utils/smartlink-outbound-url.ts`), но берёт значения
 * ТОЛЬКО из строки запроса резолва. Страница звала резолв без меток — и
 * посетитель уезжал к клиенту без клика и без кампании (остаток WEB-2123,
 * подтверждено живьём 23.09).
 *
 * ПОЧЕМУ БЕЛЫЙ СПИСОК, А НЕ ВСЯ СТРОКА. Во всей строке может быть что угодно,
 * включая почту и телефон, а серверу нужны ровно те имена, которые он читает:
 * пять меток кампании (`extractCampaignFromQuery`) и клик-параметры
 * (`extractClickIdFromQuery` — первое касание, `resolveLastTouchClickIdFromQuery`
 * — значение `{click_id}`: партнёрские имена и запасные метки рекламных сетей).
 * Это НЕ копия `OUTBOUND_MACRO_NAMES`: там имена меток в адресе назначения, здесь
 * имена параметров в адресе ВХОДА, из которых сервер эти метки собирает
 * (`{click_id}` наполняется из шести разных имён). `visitor_id` сюда не входит:
 * у умной ссылки браузерного идентификатора нет (докблок
 * `smartlink-outbound-url.ts`), а `visitorId` резолва страница ставит сама.
 *
 * СВЕРКА С СЕРВЕРОМ — в обе стороны и исполнением, а не чтением текста:
 * `backend/src/shared/guards/smartlink-visitor-query-ends.web2783.spec.ts`
 * сравнивает этот список с множеством имён, которые серверный разбор реально
 * читает, и прогоняет строки общей таблицы
 * (`outbound-url-macros.cases.json`, поле `smartLinkLanding`) через ЭТУ функцию
 * и серверную подстановку подряд.
 *
 * Согласие посетителя здесь не проверяется — так записано в документации для
 * разработчика (коммит 55cff0310): у умной ссылки замка согласия нет, решение
 * владельца о нём — отдельная карточка.
 */
export const SMART_LINK_VISITOR_PARAMS: readonly string[] =
  'utm_source utm_medium utm_campaign utm_content utm_term click_id sub_id clickid gclid fbclid ttclid'.split(
    ' ',
  );

/**
 * Хвост для строки параметров резолва: `&имя=значение` на каждую метку из
 * белого списка, только непустые и только переданные ОДИН раз — повтор сервер
 * (`qs`, режим `extended`) получает массивом и не берёт, отсылать его незачем.
 * Меток нет — пустая строка. Форма «готовый хвост» и разбиение строки вместо
 * массива литералов — ради веса первого экрана (код едет в запросе резолва).
 */
export function smartLinkVisitorQuery(
  search: string | null | undefined,
): string {
  const from = new URLSearchParams(search ?? '');
  return SMART_LINK_VISITOR_PARAMS.map((name) => {
    const values = from.getAll(name);
    return values.length === 1 && values[0]
      ? `&${name}=${encodeURIComponent(values[0])}`
      : '';
  }).join('');
}
